// The URL prefixes of the translated site (/de/pricing/) as plain JS: Node
// build scripts import src/utils/siteDomains.js (scripts/postbuild-marketing.mjs)
// and can't load the JSON registry without import attributes. Must match the
// prefixes in data/languages.json (languagePrefixes.test.js checks).
export const LANGUAGE_PREFIXES = ["es", "fr", "de", "it", "pt", "nl", "pl", "sv", "da", "no", "fi", "cs", "sk", "hu", "ro", "bg", "el", "hr", "sl", "et", "lv", "lt", "ja"];

// "/de/pricing/" -> "/pricing/"; anything else unchanged.
export function withoutLanguagePrefix(pathname) {
  const value = String(pathname ?? "");
  const match = /^\/([a-z]{2})(?=\/|$)/.exec(value);
  if (!match || !LANGUAGE_PREFIXES.includes(match[1])) return value;
  return value.slice(match[0].length) || "/";
}
